<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="t9">By</span> C<span class="t10">AITLIN</span> R<span class="t10">ICCI</span></p>
<p class="p0"><span class="t9">Crush</span></p>
<p class="p0"><span class="t9">First Time for Everything (Harmony Ink Anthology)</span></p>
<p class="p0"><span class="t9">Weathering the Storm</span></p>
<p class="p7"><span class="t9">Published by</span> H<span class="t10">ARMONY</span> I<span class="t10">NK</span> P<span class="t10">RESS</span></p>
<p class="p0"><span class="t9">www.harmonyinkpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?492ad1c6